export default "__VITE_ASSET__BAyBJtWP__"